import "./InnerBanner.css";
import defaultBgImage from "../assets/hero-removebg-preview.png";

const InnerBanner = ({
  title,
  bgImage,
  fullHeight = false,
  brand = "default",
}) => {

  const bannerImage = bgImage || defaultBgImage;

  return (
    <div
      className={`inner-banner ${brand}-banner ${
        fullHeight ? "full-height" : ""
      }`}
      style={{ backgroundImage: `url(${bannerImage})` }}
    >
      <div className="inner-overlay">
        <div className="inner-content">
          <h1>{title}</h1>
        </div>
      </div>
    </div>
  );
};

export default InnerBanner;